import { CloseOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import { DateInput, SelectInput, useRedirect, useRefresh } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonSubmit from "../unit/CustomButtonSubmit";
import HmTextInput from "../unit/HmTextInput";
import useNotify from "../unit/useNotify";
import { useForm, FormProvider } from "react-hook-form";
const BankAdd = (props: any) => {
  const refresh = useRefresh();
  const methods = useForm();
  const redirect = useRedirect();
  const id = 99999;
  const { success, error, info } = useNotify();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    refresh();
  };
  const validateBankCodeInput = (value: any) => {
    if (!value) return "required";

    if (/\s/.test(value)) {
      return "not contain spaces";
    }

    if (!/^[a-zA-Z]/.test(value)) {
      return "must start with a letter";
    }

    if (value.length > 128) {
      return "length cannot exceed 128 characters";
    }

    return undefined;
  };
  return (
    <>
      <Button
        id="btn-list-add-bank"
        onClick={handleOpen}
        variant="text"
        color="primary"
        size="small"
        sx={{
          width: "120px",
          minWidth: "120px",
          color: "primary.main",
          "&.MuiButton-sizeSmall": {
            lineHeight: 1.5,
            fontSize: "0.875rem",
          },
        }}
      >
        <AddIcon sx={{ fontSize: "1.25rem" }} /> Institution
      </Button>
      <FormProvider {...methods}>
        <Dialog
          id="dialog-bank-add"
          className="bank_add_dialog"
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="md"
          PaperProps={{
            component: "form",
            onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              let formJson = Object.fromEntries((formData as any).entries());

              console.log("formJson===>", formJson);

              const reqUrl = `banks/actions/add`;
              const response = await sendRequest(reqUrl, {
                id: "new",
                data: formJson,
              });

              if (response && response.code == "200") {
                success("Data saved successfully");
                handleClose();
              } else {
                error(response?.message || "Data not saved!");
              }
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: "bold",
              mb: 2,
              borderBottom: "1px solid #e5e5e5",
              color: "#465384",
              textTransform: "uppercase",
            }}
          >
            Add Institution
            <IconButton
              style={{ position: "absolute", right: "10px", top: "10px" }}
              onClick={handleClose}
            >
              <CloseOutlined />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                width: "100%",
                pt: 1,
                height: "50vh",
                maxHeight: "50vh",
              }}
            >
              <Box
                sx={{
                  pt: 1,
                  pb: 1,
                  width: "100%",
                }}
                className="bank_profile_info"
              >
                <HmTextInput
                  source="sBankName"
                  label="Institution Name"
                  readonly={true}
                  required={true}
                />
                <HmTextInput
                  source="sBank"
                  label="Institution Code"
                  validate={validateBankCodeInput}
                  readonly={true}
                  required={true}
                />

                <SelectInput
                  source="sOrganizationType"
                  label="Type of Organization"
                  choices={[
                    { id: "Bank", name: "Bank" },
                    { id: "Credit Union", name: "Credit Union" },
                    { id: "CDFI", name: "CDFI" },
                    { id: "Other", name: "Other" },
                  ]}
                  fullWidth
                  variant="outlined"
                  helperText={false}
                  required
                />

                <SelectInput
                  source="sBussinessType"
                  label="Business Type"
                  choices={[
                    {
                      id: "soleProprietorship",
                      name: "Sole proprietorships/Unincorporated association/Trust",
                    },
                    {
                      id: "corporation",
                      name: "Corporation/Publicly traded corporations/Non-Profits",
                    },
                    { id: "llc", name: "LLCs" },
                    {
                      id: "partnership",
                      name: "Partnerships,LP's,LLP's",
                    },
                  ]}
                  fullWidth
                  variant="outlined"
                  helperText={false}
                  required
                />
                <SelectInput
                  source="sBussinessClassification"
                  label="Industry"
                  choices={[
                    {
                      id: "Credit union",
                      name: "Credit union",
                    },
                    {
                      id: "Mortgage brokers and dealers",
                      name: "Mortgage brokers and dealers",
                    },
                    {
                      id: "Consumer lending",
                      name: "Consumer lending",
                    },
                    {
                      id: "Commercial Banking",
                      name: "Commercial Banking",
                    },
                  ]}
                  fullWidth
                  variant="outlined"
                  helperText={false}
                  required
                />
                <HmTextInput
                  source="sEin"
                  label="Institution EIN"
                  className="numericText"
                  required={true}
                />

                <Grid
                  container
                  spacing={2}
                  sx={{
                    mt: "0px",
                    pt: "0px",
                    "& .MuiGrid-item": { mt: "0px", pt: "0px" },
                  }}
                >
                  <Grid item xs={12} sm={6} sx={{ mt: "0px", pt: "0px" }}>
                    <HmTextInput source="sStreet" label="Street" />
                  </Grid>
                  <Grid item xs={12} sm={6} sx={{ mt: "0px", pt: "0px" }}>
                    <HmTextInput source="sStreet2" label="Street 2" />
                  </Grid>
                  <Grid item xs={12} sm={6} sx={{ mt: "0px", pt: "0px" }}>
                    <HmTextInput source="sCity" label="City" />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <HmTextInput source="sState" label="State" />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <HmTextInput
                      source="sZip"
                      label="Zip Code"
                      className="numericText"
                    />
                  </Grid>
                </Grid>
                {/* Institution Website */}

                <HmTextInput
                  source="sUrl"
                  label="Institution Website"
                  format={(value: any) => {
                    if (value && !value.startsWith("http")) {
                      return `http://${value}`;
                    }
                    return value;
                  }}
                  parse={(value: any) => {
                    if (value && !value.startsWith("http")) {
                      return `http://${value}`;
                    }
                    return value;
                  }}
                />
                <Grid
                  container
                  spacing={2}
                  sx={{
                    mt: "0px",
                    pt: "0px",
                    "& .MuiGrid-item": { mt: "0px", pt: "0px" },
                  }}
                >
                  <Grid item xs={6} sm={6}>
                    <DateInput
                      source="dProbationStartTime"
                      label="Probation Start Date"
                      variant="outlined"
                      defaultValue={new Date()}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <DateInput
                      source="dProbationEndTime"
                      label="Probation End Date"
                      variant="outlined"
                      defaultValue={
                        new Date(new Date().setDate(new Date().getDate() + 30))
                      }
                      onChange={(event: any) => {
                        const value = event.target.value;
                        if (value) {
                          const startDate = new Date(
                            document.querySelector(
                              'input[name="dProbationStartTime"]'
                            )?.value
                          );
                          const endDate = new Date(value);
                          if (endDate < startDate) {
                            error(
                              "Probation End Date cannot be before Start Date"
                            );
                            document.querySelector(
                              'input[name="dProbationEndTime"]'
                            )!.value = "";
                          }
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <CustomButtonSubmit label="Add" />
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default BankAdd;
